@if (user) {
  <div class="card">
    <div class="card-content">
      <p class="title">
        {{ user.profile.given_name }} {{ user.profile.family_name }}
      </p>
      <p class="subtitle">{{ user.profile.email }} <span class="is-size-6">(UserId: {{user.profile.sub}})</span></p>

      <div class="content">
        <div class="is-size-4 content has-text-weight-bold">{{ 'authentication.userProfile.roles' | localize }}:
          @for (role of roles; track role; let last = $last) {
            <span class="is-size-4 has-text-weight-normal">{{ role }}{{ last ? '' : ', ' }}</span>
          }
        </div>
        <!-- -->
        <div class="is-size-4 content has-text-weight-bold">{{ 'authentication.userProfile.insuranceCompany' | localize }}: <span
          class="is-size-4 has-text-weight-normal">{{ insuranceCompany }}</span></div>
        <!-- -->
        <div class="is-size-4 content has-text-weight-bold">{{ 'authentication.userProfile.lossAdjusterCompany' | localize }}: <span
          class="is-size-4 has-text-weight-normal">{{ lossAdjusterCompany }}</span>
        </div>

        <!-- Build Information -->
        <div class="content mt-5 pt-4" style="border-top: 1px solid #dbdbdb;">
          <div class="is-size-6 has-text-grey">
            <div class="columns is-gapless is-mobile">
              <div class="column">
                <strong>Version:</strong> {{ version }}
              </div>
            </div>
            <div class="columns is-gapless is-mobile">
              <div class="column">
                <strong>Commit/Tag:</strong>
                <span class="tag is-light is-small" title="{{ commitId }}">{{ commitIdShort }}</span>
              </div>
            </div>
            <div class="columns is-gapless is-mobile">
              <div class="column">
                <strong>Built:</strong> {{ buildDate }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
}

